import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { SuiviComponent } from "src/app/formulaire/modal/suivi/suivi.component";
import { TrouverEmployeeModalComponent } from "src/app/formulaire/modal/trouver-employee-modal/trouver-employee-modal.component";
import { ReportingService } from 'src/app/reporting/core/service/reporting.service';

@Component({
  selector: "app-historique-tache",
  templateUrl: "./historique-tache.component.html",
  styleUrls: ["./historique-tache.component.scss"],
})
export class HistoriqueTacheComponent {
  username: String;

  dossiers: Request[];
  pageHistory: number = 1;
  totalElementsHistory: number = 0;
  filterHistory: String = "";
  isLoadingResults = true;

  formulaire: FormulaireDTO;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _keycloakService: KeycloakService,
    private _requestService: RequestService,
    private _formulaireService: FormulaireService,
    private _reportingService: ReportingService
  ) {
    this.username = _keycloakService.getUsername();
  }

  ngOnInit() {
    this.getRequestsHistoryByWorkflowAndUsername(
      "_",
      this.filterHistory,
      this.username,
      0,
      5
    );
  }

  getRequestsHistoryByWorkflowAndUsername(
    workflow,
    filter,
    username,
    page,
    size
  ) {
    this.isLoadingResults = true;
    this._requestService
      .getRequestsHistoryByWorkflowAndUsername(
        workflow,
        filter,
        username,
        "_",
        "",
        "",
        page,
        size,"id","desc"
      )
      .pipe(first())
      .subscribe(
        (data) => {
          debugger;
          this.isLoadingResults = false;
          this.dossiers = data.content;
          this.totalElementsHistory = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  //
  loadPageHistory(page: number): void {
    page = page - 1;
    this.getRequestsHistoryByWorkflowAndUsername(
      "_",
      this.filterHistory,
      this.username,
      page,
      5
    );
  }

  searchAndRefreshHistory(): void {
    this.getRequestsHistoryByWorkflowAndUsername(
      "_",
      this.filterHistory,
      this.username,
      0,
      5
    );
  }
  //

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  suivi(requestId) {
    const modalRef = this.modalService.open(SuiviComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestId = requestId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {}
    );
  }

  recherche(): void {
    const modalRef = this.modalService.open(TrouverEmployeeModalComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.username = data;

        this.searchAndRefreshHistory();
      },
      (reason) => {
        // on dismiss
      }
    );
  }


  
  exportRequestsHistoryByInitiateur() {
    let deb =  "";
    let fn =  "";

    this._reportingService
      .exportRequestsHistoryByInitiateur(
        "_",
        "_",
        this.username,
        "",
        deb,
        fn
      )
      .subscribe((blob) => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "requests-history-" + deb + ".xlsx");
        document.body.appendChild(link);
        link.click();
      });
  }

}
